import { FileText, Mail, Settings, User } from "react-feather";

export const LanguagesData = [
  { data: "en", icon: "us", language: "English" },
  { data: "du", icon: "de", language: "Deutsch" },
  { data: "es", icon: "es", language: "Español" },
  { data: "fr", icon: "fr", language: "Français" },
  { data: "pt", icon: "pt", language: "Português" },
  { data: "cn", icon: "cn", language: "简体中文" },
  { data: "ae", icon: "ae", language: "لعربية" },
];

export const BookMarkData = [
  {
    icon: "form",
    title: "Forms",
    url: `${process.env.PUBLIC_URL}/forms/form_controls/form_validation`,
  },
  {
    icon: "user",
    title: "Profile",
    url: `${process.env.PUBLIC_URL}/applications/users/user_profile`,
  },
  {
    icon: "table",
    title: "Tables",
    url: `${process.env.PUBLIC_URL}/table/reactstrap_tables/basic_table`,
  },
];

//CartHeader
export const CartHeaderData = [
  { id: 1, image: "15.png", name: "Women Bag", price: 500, quantity: 1 },
  {
    id: 2,
    image: "13.png",
    name: "Apple Smartwatch",
    price: 500.0,
    quantity: 1,
  },
];

//Notitications
export const NotiticationsData = [
  { id: 1, color: "primary", name: "Delivery processing", time: "10 min." },
  { id: 2, color: "success", name: "Order Complete", time: "1 hr." },
  { id: 3, color: "secondary", name: "Tickets Generated", time: "3 hr." },
  { id: 4, color: "warning", name: "Delivery Complete", time: "6 hr." },
];

//Profile
export const ProfileHeaderData = [
  {
    id: 1,
    link: `applications/users/user_profile`,
    icon: <User />,
    text: "Account",
  },
  // {
  //   id: 2,
  //   link: `applications/email/letter_box`,
  //   icon: <Mail />,
  //   text: "Inbox",
  // },
  // {
  //   id: 3, link: `applications/task`, icon: <FileText />, text: "Taskboard"
  // },
  {
    id: 2,
    link: `applications/users/edit_profile`,
    icon: <Settings />,
    text: "Settings",
  },
];
